// icons/index.jsindex.jsicons
import Vue from 'vue'
import SvgIcon from '@/components/SvgIconBtn/index'// svg组件

// register globally
Vue.component('svg-btn', SvgIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
